/**
 * "Zespół" bio popup — a single native <dialog> reused for every team
 * member. showModal() gives focus trapping + Esc-to-close for free; we just
 * populate the dialog's content from the clicked card's data-* attributes
 * and its <template data-team-bio> before opening it.
 */
export function initTeamPopups() {
	const dialog = document.querySelector( '[data-team-popup]' );
	const triggers = document.querySelectorAll( '[data-team-trigger]' );

	if ( ! dialog || ! triggers.length ) {
		return;
	}

	const photoEl = dialog.querySelector( '[data-team-popup-photo]' );
	const avatarEl = dialog.querySelector( '[data-team-popup-avatar]' );
	const initialsEl = dialog.querySelector( '[data-team-popup-initials]' );
	const nameEl = dialog.querySelector( '[data-team-popup-name]' );
	const roleEl = dialog.querySelector( '[data-team-popup-role]' );
	const bioEl = dialog.querySelector( '[data-team-popup-bio]' );
	const closeBtn = dialog.querySelector( '[data-team-popup-close]' );

	let lastTrigger = null;

	function initialsFrom( name ) {
		return name
			.split( /\s+/ )
			.slice( 0, 2 )
			.map( ( word ) => word.charAt( 0 ).toUpperCase() )
			.join( '' );
	}

	triggers.forEach( ( trigger ) => {
		trigger.addEventListener( 'click', () => {
			const { name = '', role = '', photo = '' } = trigger.dataset;

			if ( photo ) {
				photoEl.src = photo;
				photoEl.alt = name;
				photoEl.hidden = false;
				avatarEl.hidden = true;
			} else {
				photoEl.hidden = true;
				avatarEl.hidden = false;
				initialsEl.textContent = initialsFrom( name );
			}

			nameEl.textContent = name;
			roleEl.textContent = role;

			bioEl.innerHTML = '';
			const template = trigger.closest( 'article' )?.querySelector( 'template[data-team-bio]' );
			if ( template ) {
				bioEl.append( template.content.cloneNode( true ) );
			}

			lastTrigger = trigger;
			dialog.showModal();
		} );
	} );

	closeBtn?.addEventListener( 'click', () => dialog.close() );

	dialog.addEventListener( 'click', ( event ) => {
		if ( event.target === dialog ) {
			dialog.close();
		}
	} );

	dialog.addEventListener( 'close', () => {
		lastTrigger?.focus();
	} );
}
